module.exports = __webpack_public_path__ + "img/manatcomputer.2a508c24.svg";